import React from "react";
import { login_expired, haire_gif_new } from "../../assets/images/images";
import { Link } from "react-router-dom";
import "./LoginLinkExpired.css";

const LoginLinkExpired = () => {
  return (
    <>
      <nav className="link-expired-navbar">
        <Link to="/">
          <img
            src={haire_gif_new}
            alt="Haire"
            className="link-expired-nav-logo"
          />
        </Link>
      </nav>
      <div className="link-expired-page">
        <div className="link-expired-content">
          <h2 className="link-expired-title">login link expired</h2>
          <img
            src={login_expired}
            alt="Link expired"
            className="link-expired-illustration"
          />
          <p className="link-expired-message">
            This access link is no longer valid.
          </p>
          <p className="link-expired-submessage">
            Please contact your administrator to request a new invite.
          </p>
        </div>
      </div>
    </>
  );
};

export default LoginLinkExpired;
